import {
    TOOLBAR_CHOOSE_TYPE,
    TOOLBAR_CHOOSE_TOOLTIP_TYPE,
    TOOLBAR_POPOVER_OPENED,
    TOOLBAR_POPOVER_CLOSED,
} from 'state/actions/toolbar'

const initialState = {
    reserveType: null,
    tooltipReserveType: null,
    popoverOpened: false,
}


export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case TOOLBAR_CHOOSE_TYPE:
        return {
            ...state,
            reserveType: action.payload.reserveType,
        }
    case TOOLBAR_CHOOSE_TOOLTIP_TYPE:
        return {
            ...state,
            tooltipReserveType: action.payload.reserveType,
        }
    case TOOLBAR_POPOVER_OPENED:
        return {
            ...state,
            popoverOpened: true,
        }
    case TOOLBAR_POPOVER_CLOSED:
        return {
            ...state,
            popoverOpened: false,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/toolbar.js